/*
 *  Adapted from:
 *  https://www.w3.org/WAI/ARIA/apg/example-index/dialog-modal/dialog#javascriptandcsssourcecode
 *  https://www.w3.org/WAI/ARIA/apg/example-index/dialog-modal/js/dialog.js
 */

var isFocusable = function isFocusable(element) {
  if (element.tabIndex < 0) {
    // elements are focusable but omitted from tabbing order
    return true;
  }
  if (element.disabled) {
    return false;
  }
  switch (element.nodeName) {
    case 'A':
      return !!element.href && element.rel != 'ignore';
    case 'INPUT':
      return element.type != 'hidden';
    case 'BUTTON':
    case 'SELECT':
    case 'TEXTAREA':
      return true;
    default:
      return false;
  }
};

/**
 * @description Set Attempt to set focus on the current node.
 * @param element
 *          The node to attempt to focus on.
 * @returns {boolean}
 *  true if element is focused.
 */
var attemptFocus = function attemptFocus(element) {
  if (!isFocusable(element)) {
    return false;
  }
  try {
    element.focus();
  } catch (e) {
    // continue regardless of error
  }
  var rootNode = element.getRootNode();

  // Also check against rootNode.activeElement to handle edge cases where the implementation
  // is nested within a Shadow Root which lacks direct access to the global document object
  return document.activeElement === element || rootNode.activeElement === element;
}; // end attemptFocus

/**
 * @description Set focus on descendant nodes until the first focusable element is
 *       found.
 * @param element
 *          DOM node for which to find the first focusable descendant.
 * @returns {boolean}
 *  true if a focusable element is found and focus is set.
 */
var focusFirstDescendant = function focusFirstDescendant(element) {
  for (var i = 0; i < element.childNodes.length; i++) {
    var child = element.childNodes[i];
    if (attemptFocus(child) || focusFirstDescendant(child)) {
      return true;
    }
  }
  return false;
}; // end focusFirstDescendant

export { attemptFocus, focusFirstDescendant };
